module.exports = __webpack_public_path__ + "img/Logo.8170c2d5.svg";